import { render, staticRenderFns } from "./CuentasCorrientes.vue?vue&type=template&id=a0b32408"
import script from "./CuentasCorrientes.vue?vue&type=script&lang=js"
export * from "./CuentasCorrientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports